import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { MatIconModule } from '@angular/material/icon';
import { LayoutService } from '@itm/services';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseUtilsService } from '@fuse/services/utils';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'itm-mobile-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './mobile-footer.component.html',
  styleUrl: './mobile-footer.component.scss',
  // encapsulation: ViewEncapsulation.None,
  imports: [CommonModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
  ]
})
export class ItmMobileFooterComponent {
  private readonly _fuseUtilsService = inject(FuseUtilsService);
  private readonly _ls = inject(LayoutService);

  ///inputs
  navigation = input.required<FuseNavigationItem[]>();

  isActiveMatchOptions: IsActiveMatchOptions = this._fuseUtilsService.subsetMatchOptions;

  constructor(){
    effect(() => {
      // console.log(this.navigation())
    });
  }

  ngOnInit(): void {
  }

  /**
 * Track by function for ngFor loops
 *
 * @param index
 * @param item
 */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
  
  public toolbarClick(args: ClickEventArgs): void { 
    console.log(args)
    const buttonText = args?.item?.id;
    if (buttonText != '') {
      this._ls.setToolbarButtonClick(buttonText);
    }
  }

}
